export default function MainHeadingSeparator() {
  return <div className="border-t-[2px] border-black/20"></div>;
}
